module.exports = __webpack_public_path__ + "static/media/brands_FLOMATIC.e61c235c.svg";